module.exports = __webpack_public_path__ + "1e670d88b23c7ab956f1829e3828a210.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Digital/Digital.ttf
// module id = 376
// module chunks = 0